import getHasSampledProductDataSelector from 'modules/product/redux/selectors/get-has-sampled-product-data'
import hasSampledAndRatedVariantSelectorUtil from 'modules/variant/redux/selectors/has-sampled-and-rated/utils'
import hasSampledVariantSelector from 'modules/variant/redux/selectors/has-sampled'

const hasSampledAndRatedVariantSelector = (variantId) => state => {
  const data = getHasSampledProductDataSelector(variantId)(state)
  const hasSampled = hasSampledVariantSelector(variantId)(state)
  return hasSampledAndRatedVariantSelectorUtil({
    data,
    hasSampled
  })
}

export default hasSampledAndRatedVariantSelector
